import enGB from "../../en-GB/en-GB";
export default defineI18nLocale(() => enGB);
